import { startCase, toLower } from 'lodash';
export interface NameUtil {
  getFullName: (firstName: string, lastName: string) => string;
}

export function useName(): NameUtil {
  const getFullName = (firstName: string, lastName: string): string => {
    // per latest feedback names need to be displayed as lastname, firstname
    return `${startCase(toLower(lastName))}, ${startCase(toLower(firstName))}`;
  };

  return { getFullName: getFullName };
}
